import {Button} from '@chekinapp/ui';
import {closeSession} from 'components/sessions/utils';
import {useTranslation} from 'react-i18next';
import {useReservation} from 'context/reservation';
import {LogOut} from 'lucide-react';

function ExitReservationButton() {
  const {t} = useTranslation('kiosko');
  const {reservationId} = useReservation();

  const handleExit = () => {
    closeSession(reservationId);
  };

  return (
    <Button
      onClick={handleExit}
      className="kiosko:!w-full kiosko:text-kiosko-m kiosko:h-[112px] !border-[2px] !rounded-[56px] flex gap-5 mt-[56px]"
      variant="outline"
    >
      <LogOut size={48} className="kiosko:w-12 kiosko:h-12" />
      {t('exit_reservation')}
    </Button>
  );
}

export {ExitReservationButton};
